import React from 'react';

export interface IUserNotificationsContext {
  readUserNotification: (notificationId: string, read: boolean) => Promise<void>;
  readUserNotifications: () => Promise<void>;
  readUserNotificationLoading: boolean;
  readUserNotificationsLoading: boolean;
}

const UserNotificationsContext = React.createContext<IUserNotificationsContext>({
  readUserNotification: () => Promise.resolve(),
  readUserNotifications: () => Promise.resolve(),
  readUserNotificationLoading: false,
  readUserNotificationsLoading: false,
});

export default UserNotificationsContext;
